import { createListenerMiddleware, TypedStartListening } from "@reduxjs/toolkit";
import { AppDispatch, AppState } from "@app/store/store";
import { logoutUserSessions } from "@entities/auth";
import { applyThemeByUserType } from "@shared/lib/theme";

export const logoutListenerMiddleware = createListenerMiddleware();

type LogoutStartListening = TypedStartListening<AppState, AppDispatch>;
const startListening = logoutListenerMiddleware.startListening as LogoutStartListening;

startListening({
    actionCreator: logoutUserSessions.fulfilled,
    effect: async () => {
        applyThemeByUserType(false);
    }
});